module.exports = __webpack_public_path__ + "baa04bd2af9ec2c85129b024766b0f76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_32.jpg
// module id = 1776
// module chunks = 5